import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const changeInAppVisitStatus = async ({ payload }) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/photos/change_inapp_visit_status/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useChangeInAppVisitStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeInAppVisitStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["visit_schedule"] });
      queryClient.invalidateQueries({ queryKey: ["special_visit_sessions"] });
      queryClient.invalidateQueries({ queryKey: ["visits_status_dropdown"] });
      queryClient.invalidateQueries({ queryKey: ["visit_overview"] });
    },
  });
};

export default useChangeInAppVisitStatusMutation;
